/**
 * @description Renders a 404 page
 */

import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const styles = {
  container: {
    alignItems: 'center',
    height: '100%',
    justifyContent: 'center',
    width: '100%'
  },
  icon: {
    height: '5rem',
    width: '5rem'
  },
  text: {
    fontSize: 'h6.fontSize',
    fontWeight: 'bold'
  }
}

const NotFound = () => (
  <Stack spacing={3} sx={styles.container}>
    <WarningAmberIcon sx={styles.icon} />
    <Typography sx={styles.text}>The page you are trying to access could not be found.</Typography>
    <Typography sx={styles.text}>Check the address in your browser and try again.</Typography>
  </Stack>
);

export default NotFound;
